export * from './SchoolAdminPageHeroBanner'
